import styled from "styled-components";
import {Card} from "antd";

export const StyledCard = styled(Card)`
    margin: 20px;
    height: 100%;
`;

export const SwitchContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    .label {
        font-size: 14px;
    }
`;

export const FormItem = styled.div`
    margin-bottom: 16px;

    .label {
        font-size: 14px;
        margin-bottom: 8px;
    }

    .error {
        color: #ff4d4f;
        font-size: 12px;
        margin-top: 4px;
    }
`;

export const UpdateButton = styled.button`
    padding: 8px 16px;
    background-color: #1890ff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;

    &:disabled {
        background-color: #d9d9d9;
        cursor: not-allowed;
    }
`;
